import React from "react";
import { withRouter } from "react-router-dom";
import FormTabs from "../genericModifyPage/FormTabs";
import InvoiceDetailsForm from "./InvoiceDetailsForm";
import InvoiceFinalStepForm from "./InvoiceFinalStepForm";

function InvoiceForm(props) {
  const [item, onChanged, onSave, onCancel] = [
    props.item,
    props.onChanged,
    props.onSave,
    props.onCancel,
  ];

  return (
    <FormTabs
      item={item}
      onChanged={onChanged}
      onSave={onSave}
      onCancel={onCancel}
      history={props.history}
      pageProps={props.pageProps}
      tabs={[
        {
          title: "Details",
          body: <InvoiceDetailsForm />,
        },
        {
          title: "Final step",
          body: <InvoiceFinalStepForm />,
        },
      ]}
    />
  );
}

export default withRouter(InvoiceForm);
